export const endPoints = {
	auth: {
		// authenticate: '/authenticate',
		login: '/auth/user',
		logout: '/logout',
		changePassword: '/UserProfile/ChangePassword',
		verifyEmail: '/UserProfile/VerifyEmail',
		verifyOtp: '/UserProfile/VerifyOTP',
		forgetPassword: '/UserProfile/ForgetPassword',
		verifyPassword: '/UserProfile/Verify'
	},
	client: {
		onboarding: '/backend/client/onboarding',
		update: '/backend/client/update',
	},
	dashboard: {
		fetchCount: '/shareholder/count',
		fetchPostsCount: '/posts/count',
	},
	file: {
		upload: '/upload',
	},
	companies: {
		list: '/backend/fetch/clients-pagination',
		count: '/backend/fetch/clients-meta',
	},
	aboutUs: {
		fetch: '/fetch/about',
		create: '/create/about',
		update: '/update/about',
		delete: '/delete/about',
	},
	users: {
		list: '/client/agents-paginated',
		create: '/backend/users/create',
		update: '/backend/users/update-partial',
	},
	posts: {
		fetch: '/posts',
		create: '/create/post',
		update: '/update/post',
		delete: '/delete/post',
		statusUpdate: '/update/post/status',
		// Categories
		createCat: '/create/post_category',
		updateCat: '/update/post_category',
		deleteCat: '/delete/post_category',
		getCategories: '/fetch/post_categories',
		// Resources
		getResources: '/fetch/resources',
		createResource: '/create/resource',
		updateResource: '/update/resource',
		deleteResource: '/delete/resource',
	},
	news: {
		fetch: '/fetch/news',
		create: '/create/news',
		update: '/update/news',
		delete: '/delete/news',
		fetchCompNews: '/fetch/news/company_news',
		rejectNews: '/reject/news',
	},
	webinars: {
		fetch: '/fetch/shareholder/webinarl',
		create: '/create/shareholder/webinar',
		update: '/update/shareholder/webinar',
		delete: '/delete/shareholder/webinar',
	},
	sliders: {
		create: '/create/slider',
		update: '/update/slider',
		delete: '/delete/slider',
		getSliders: '/fetch/sliders',
	},
	slides: {
		create: '/create/slide',
		update: '/update/slide',
		delete: '/delete/slide',
		getSlides: '/fetch/slides',
	},
	tutorialVideo: {
		create: '/create/tutorial-video',
		update: '/update/tutorial-video',
		fetch: '/fetch/tutorial-videos',
		fetchActive: '/fetch/tutorial-video/active',
		delete: '/delete/tutorial-video',
	},
	shareHolderRights: {
		// Documents
		fetchAll: '/fetch/shareholder',
		createDoc: '/create/shareholder/document',
		updateDoc: '/update/shareholder/document',
		deleteDoc: '/delete/shareholder/document',
		// Videos
		// fetchVid: '/fetch/shareholder/video',
		createVid: '/create/shareholder/video',
		updateVid: '/update/shareholder/video',
		deleteVid: '/delete/shareholder/video',
		// Webinars
		// fetchWebinar: '/fetch/shareholder/webinar',
		createWebinar: '/create/shareholder/webinar',
		updateWebinar: '/update/shareholder/webinar',
		deleteWebinar: '/delete/shareholder/webinar',
		// Faqs
		fetchFaqs: '/fetch/faqs',
		createFaqs: '/create/faq',
		updateFaqs: '/update/faq',
		deleteFaqs: '/delete/faq',
	},
	shareHolderEducation: {
		// Course
		fetchCourse: '/fetch/course',
		createCourse: '/create/course',
		updateCourse: '/update/course',
		deleteCourse: '/delete/course',
		// Course Quizzes
		fetchQuiz: '/fetch/quizzes',
		createQuiz: '/create/quize',
		updateQuiz: '/update/quize',
		deleteQuiz: '/delete/quize',
		// Webinars & Evants
		fetchWebinar: '/fetch/shareholder',
		createWebinar: '/create/shareholder/webinar',
		updateWebinar: '/update/shareholder/webinar',
		deleteWebinarStatus: '/delete/shareholder/webinar',
		fetchArchive: '/fetch/archived/webinars',
		updateWebinarOrder: '/update/archived/order',
		deleteWebinar: '/delete/archived/webinar',
		// Podcasts
		fetchPodcast: '/fetch/shareholder',
		createPodcast: '/create/shareholder/podcast',
		updatePodcast: '/update/shareholder/podcast',
		deletePodcast: '/delete/shareholder/podcast',
		// Presentations
		fetchPresentation: '/fetch/shareholder',
		createPresentation: '/create/shareholder/presentation',
		updatePresentation: '/update/shareholder/presentation',
		deletePresentation: '/delete/shareholder/presentation',
		// Governance Updates
		fetchGovernanceUpdate: '/fetch/shareholder',
		createGovernanceUpdate: '/create/shareholder/governance-update',
		updateGovernanceUpdate: '/update/shareholder/governance-update',
		deleteGovernanceUpdate: '/delete/shareholder/governance-update',


	},
	profile: {
		update: '/backend/users/update',

	},
	complaintForms: {
		fetch: '/fetch/inquiries',
		delete: '/delete/inquiry',
	},
	eServices: {
		// E-VOTING
		fetchEVoting: '/fetch/shareholder',
		createEVoting: '/create/shareholder/eVoting',
		updateEVoting: '/update/shareholder/eVoting',
		deleteEVoting: '/delete/shareholder/eVoting',


	},
	courseCategory: {
		fetch: '/fetch/course/categories',
		create: 'create/course/category',
		update: 'update/course/category',
		delete: '/delete/course/category',
	},
	permissions: {
		get: '/backend/fetch/list/permissions',
		create: '/backend/permissions/create',
		update: '/backend/permissions/update',
	},
	rulesSet: {
		get: '/fetch/list/rule_sets',
	},
	roles: {
		get: '/backend/fetch/list/roles',
		create: '/backend/roles/create',
		update: '/backend/roles/update',
	},
	activities: {
		get: '/Activity/Get/Listing',
		getEmployee: '/Leave/GetSubordinates',
		post: '/Activity/Add',
		getById: 'Activity/GetById',
		put: 'Activity/Update',
		getShiftTimeout: 'Activity/Get/ShiftTimeoutInfo',
		getActivityBoard: 'Activity/Get/ActivityBoard'
	},
	activityGroup: {
		getAll: '/Activity/Get/ActivityGroups',
		add: '/ActivityGroup/Add',
		edit: '/ActivityGroup/Update',
		delete: '/ActivityGroup/Delete/',
		disable: '/ActivityGroup/Disable/',
	},
	subActivity: {
		getAll: '/Activity/Get/ActivityList',
		add: '/Add/Activity',
		edit: '/Update/Activity',
		delete: '/Activity/Delete/',
		disable: '/Activity/Disable/',
	},
	bank: {
		getAll: '/Bank/List',
		add: '/Bank/Add',
		edit: '/Bank/Update',
		delete: '/Bank/Delete/',
		disable: '/Bank/Disable/',
	},
	designation: {
		getAll: '/Designation/Get',
		add: '/Designation/Add',
		edit: '/Designation/Update',
		delete: '/Designation/Delete/',
		disable: '/Designation/Disable/',
		Gadres: 'Designation/Get/Gadres'
	},
	employmentStatus: {
		getAll: '/EmploymentStatus/Get/',
		add: '/EmploymentStatus/Add',
		edit: '/EmploymentStatus/Update',
		delete: '/EmploymentStatus/Delete/',
		disable: '/EmploymentStatus/Disable/',
	},
	qualification: {
		getAll: '/Qualification/Get/Qualifications',
		add: '/Qualification/Add',
		edit: '/Qualification/Update',
		delete: '/Qualification/Delete/',
		disable: '/Qualification/Disable/',
	},
	company: {
		getAll: '/Company/Get',
		add: '/Company/Add',
		edit: '/Company/Update',
		delete: '/Company/Delete/',
		disable: '/Company/Disable/',
	},
	businessUnit: {
		getAll: '/BusinessUnit/Get/BusinessUnits',
		add: '/BusinessUnit/Add/BusinessUnit',
		edit: '/BusinessUnit/Update/BusinessUnit',
		delete: '/BusinessUnit/Delete/BusinessUnit/',
		disable: '/BusinessUnit/Disable/BusinessUnit/',
	},
	location: {
		getAll: '/Location/Get',
		add: '/Location/Add',
		edit: '/Location/Update',
		delete: '/Location/Delete/',
		disable: '/Location/Disable/',
	},
	department: {
		getAll: '/Department/Get',
		add: '/Department/Add',
		edit: '/Department/Update',
		delete: '/Department/Delete/',
		disable: '/Department/Disable/',
	},
	subDepartment: {
		getAll: '/SubDepartment/Get',
		add: '/SubDepartment/Add',
		edit: '/SubDepartment/Update',
		delete: '/SubDepartment/Delete/',
		disable: '/SubDepartment/Disable/',
	},
	employeeSetup: {
		get: '/personaldetail/get',
		getWithFilter: '/PersonalDetail/List',
		getLookup: '/Lookup/get',
		getBankList: '/Bank/List',
		getEmployeeDataById: '/PersonalDetail/GetById',
		getTeamEmployees: '/PersonalDetail/ListSubordinates',
		getAccountTypes: '/Bank/AccountTypes/List',
		getListNextOfKin: '/PersonalDetail/GetById',
		putBankDetails: '/PersonalDetail/Bank/Update',
		postEmployee: 'personaldetail/Post',
		updateEmployee: '/PersonalDetail/Update',
		updatePersonal: '/PersonalDetail/Personal/Update',
		createKin: '/PersonalDetail/Kin/Add',
		putKin: '/PersonalDetail/Kin/Update',
		deleteKin: '/PersonalDetail/Kin/Delete',
		createInsurance: '/PersonalDetail/Insurance/Add',
		putInsurance: '/PersonalDetail/Insurance/Update',
		deleteInsurance: '/PersonalDetail/Insurance/Delete',
		postLeave: '/Leave/Apply',
		putPublish: '/PersonalDetail/Publish/',
		putActiveInactive: '/PersonalDetail',
		putResetPassword: '/UserProfile/ResetPassword',
		employmentStatus: '/PersonalDetail/EmploymentStatus/List',
		companyLocation: '/Location/GetByCompanyId',
		employeeConfirm: '/PersonalDetail',
		putSeparated: '/PersonalDetail/separated'
	},
	attendance: {
		attendance: {
			getAll: '/Attendance/GetById',
			GetSubordinateAttendance: 'Attendance/GetSubordinateAttendance',
		},
		leaveApprovals: {
			getAll: '/Leave/GetListing',
		},
		attendanceRegister: {
			getAll: '/Leave/GetAttendance',
		},
		timeAdjustment: {
			put: '/Attendance/Adjustment/Request',
		},
		myLeaves: {
			get: '/Leave/GetListing',
			getLeaveDays: '/Leave/Days',
		},
		myTeamLeaves: {
			getAll: '/Leave/GetListing',
		},
		attendanceAdjustment: {
			getAll: '/Attendance/Adjustment/Listing',
		},
		attendanceDecision: {
			put: '/Attendance/Adjustment/Decision',
		},
		leaveUpdate: {
			put: '/Leave/Update',
		},
	},
	shift: {
		ShiftListing: {
			getAll: '/HrShift/Get',
		},
		postHrShift: '/HrShift/Post',
		getById: '/HrShift/GetByShiftId',
		put: '/HrShift/Put',
		putAssignShiftToEmployee: 'HrShift/AssignShiftToEmployee',
	},
	lookUps: {
		getBusinessUnits: '/Lookup/Get/BusinessUnits',
		getDepartment: '/Lookup/Get/Departments',
		getSubDepartments: '/Lookup/Get/SubDepartments',
		getEmployees: '/Lookup/Get/Employees',
		getReportTo: '/PersonalDetail/List',
		getHrShift: '/HrShift/ListBySubdepartment/',
		getHrShifts: '/HrShift/GetHrShifts/',
		getShifts: '/HrShift/Get/',
		getSubOrdinates: 'Leave/GetSubordinates',
		getSubOrdinatesWithHrShift: 'PersonalDetail/ListSubordinatesWithHrShift',
		getActivity: 'Activity/Get/ActivityGroups',
		getSubActivity: 'Activity/Get/Activities',
		leaveTypes: 'Leave/GetTypes',
		leaveQuota: 'Leave/GetQuotas',
		getSubstitute: 'personaldetail/GetByDepartmentId/',
	},
	menu: {
		addMenu: 'Menu/Add',
		updateMenu: 'Menu/Update',
		deleteMenu: 'Menu/Delete/',
		addSubMenu: 'SubMenu/Add',
		updateSubMenu: 'SubMenu/Update',
		deleteSubMenu: 'SubMenu/Delete/',
		getAllMainMenu: 'Menu/Get',
		getAllSubMenu: 'SubMenu/Get',
		disabledSubMenu: 'SubMenu/Disable/',
		subMenuMapping: 'SubMenuMapping/Get/SubMenuRoles',
		postRolesMenu: '/SubMenuMapping/Change/SubMenuRoles',
		getAllMapUser: '/SubMenuMapping/Get/SubMenuUsers',
		postUserMapping: '/SubMenuMapping/Change/SubMenuUsers',
	},
	offDay: {
		get: '/Offday/List',
		subOrdinate: '/Offday/ListSubordinates',
		put: '/Offday/Update',
		add: '/Offday/Add',
		getStartDate: '/Offday/StartDate'
	},
	filters: {
		getBusinessUnits: 'BusinessUnit/Get/BusinessUnitByCompanyId/',
		getDepartment: '/BusinessUnit/Get/DepartmentsByBusinessUnitId/',
		getSubDepartments: 'SubDepartment/GetByDepartmentId/',
	},
	// dashboard: {
	// 	getEmpStats: '/Dashboard/Stats/Employee/',
	// 	getStats: '/Dashboard/Stats/Management/',
	// 	memberAbs: '/Dashboard/Stats/Management/',
	// 	memberOff: '/Dashboard/Stats/Management/',
	// 	memberPre: '/Dashboard/Stats/Management/',
	// 	memberLea: '/Dashboard/Stats/Management/',
	// 	menubarLt: '/Dashboard/Stats/Management/'
	// },
	hrReport: {
		monthlyAttendanceSummary: '/Attendance/HrAttendanceReport',
	},
	payRoll: {
		date: '/Payroll/dates',
		lock: '/Payroll/lock',
		generate: '/Payroll/generate',
		list: '/Payroll/List',
		logs: '/Payroll/Logs'
	}
};
